import type { Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';
import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import type { FlowDetailMode } from '../flow-detail.types';
import { useFlowStore } from '@/state/stores/use-flow-store';
import { slotListColumnOuterSx, slotListScrollAreaSx } from './flow-slot-list-column-sx';
import { FlowSlotAssetsUnpublishedPlaceholder } from './flow-slot-assets-slot-list-column';
import { FlowControlCueSheetRundown } from './flow-control-cue-sheet-rundown';

export type FlowControlSlotListColumnProps = {
  setShowFlowDetails: Dispatch<SetStateAction<FlowDetailMode | undefined>>;
  setFlowDetailsDirection: Dispatch<SetStateAction<'up' | 'down' | undefined>>;
  onSlotSelect?: (slot: FlowSlotDto, isUserInitiated?: boolean) => void;
  onShowTimingAlert?: () => void;
  onShowPublishAlert?: () => void;
};

/** Cue-sheet-first Control rundown. SlotList stays Plan/Organize only. */
export function FlowControlSlotListColumn({ onSlotSelect }: FlowControlSlotListColumnProps) {
  const flowPlan = useFlowStore((s) => s.flowPlan);
  const flow = useFlowStore((s) => s.flow);

  if (!flowPlan && !flow) {
    return (
      <Box sx={slotListColumnOuterSx}>
        <FlowSlotAssetsUnpublishedPlaceholder />
      </Box>
    );
  }

  return (
    <Box sx={slotListColumnOuterSx}>
      <Box sx={slotListScrollAreaSx}>
        <FlowControlCueSheetRundown onSlotSelect={onSlotSelect} />
      </Box>
    </Box>
  );
}
